import {REFERRAL_DISCOUNT} from '../../../constants';

export const WAIT_TIME_EXP = "wait_time";

export const ARTICLES = [
    {
        id: 'refer',
        title: "Refer a friend",
        desc: <>Refer a friend to InstantScripts and you will both receive ${REFERRAL_DISCOUNT} off your next order.</>,
        img: "refer-a-friend-home.jpg",
        link: "/refer-a-friend",
        secondaryBtn: "Maybe later",
        primaryBtn: <>Get ${REFERRAL_DISCOUNT} off</>
    },
    {
		id: "pulserewards",
		title: "Add your Pulse Rewards account",
		desc: "As a Pulse Rewards member, you can collect points at InstantScripts.",
		content: (
			<div className="bg-pr-mid-purple flex items-center justify-center w-full h-[200px] rounded-[28px]">
				<img src="https://storage.googleapis.com/instant-med-public/priceline/pulse-rewards.svg" alt="Pulse Rewards Logo" className="w-[209px]"
				/>
			</div>
		),
		link: "/profile#settings",
		primaryBtn: "Add now",
		secondaryLink: "/pulse-rewards",
		secondaryBtn: "Learn more",
	},
    {
        id: 'onepass',
        title: "Activate your OnePass membership",
        desc: "Get free standard delivery on eligible prescription medication in Aus.",
        content: <div className="bg-op-purple flex items-center justify-center w-full h-[200px] rounded-[28px]">
            <img src="https://storage.googleapis.com/instant-med-public/OnePass/onepass_purple_bg.svg" alt="Onepass membership" className="w-[188px]" />
        </div>,
        link: "/profile#settings",
        primaryBtn: "Activate now",
        secondaryLink: "/onepass",
        secondaryBtn: "Learn more"
    },
    {
        id: 'consults',
        title: `General telehealth consultations now $49`,
        desc: "We’ve dropped the price of telehealth consultations to make it even more convenient for you to get the healthcare you need.",
        img: "consults-home.jpg",
        link: "/c/pharm/DocCons",
        primaryBtn: "Request a consultation",
    },
    {
        id: 'certs',
        title: `Our online script service just got better!`,
        desc: "We can help ensure you don't go without your medication. We've updated our pricing and all online script requests are now just $19.",
        img: "medcert-home.jpg",
        link: "/m/pharm/online/prescription",
        primaryBtn: "Request a script"
    },
    {
        id: 'delivery',
        title: "We offer same day delivery!",
        desc: "We’ve partnered with Evermed to offer same day delivery so you don’t have to leave your house to get your medication. Small fee applies. Subject to availability in your area.",
        img: "delivery-home.jpg",
        link: "/c/pharm/DocCons",
        primaryBtn: "Request a consultation"
    },
    {
        id: 'patho',
        title: "Get a pathology referral",
        desc: "Did you know we offer a variety of pathology tests? Request a test, take the form to your local collection centre and the results will be sent to you in a few days.",
        img: "patho-referral-home.jpg",
        link: "/c/pharm/patho",
        primaryBtn: "Request a referral"
    }
]
